import ContentTitle from "components/common/ContentTitle";
import Loading from "components/common/Loading";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSmartFormList2 } from "redux/modules/ownVisaSlice";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";

import LtrType from "components/home//LtrType";
import useAuth from "libs/hooks/useAuth";
import {
  getConditionShowLTR,
  getListSmartForm,
  selectListSmartForm,
  setSmartServiceId
} from "redux/modules/visaForm";
import Swal from "sweetalert2";

function LtrServiceTab() {
  const dispatch = useDispatch();
  const listSmartFormState = useSelector(selectListSmartForm);
  const hasCreatedSmartForm = listSmartFormState.data.length;
  const { personalID } = useSelector((state) => state.personal.detail);
  const { list: ownVisaList } = useSelector((state) => state.ownVisa);

  const hasSmartFormComplete = listSmartFormState.data.some(
    (v) => v.statusDocName === "Completed"
  );
  const hasSmartFormDraft = listSmartFormState.data.some(
    (v) => v.statusDocName === "Draft"
  );
  const smartFormDraft = listSmartFormState.data.filter(
    (v) => v.statusDocName === "Draft"
  );
  const shouldShowContinue = hasCreatedSmartForm && hasSmartFormDraft;
  const shouldShowVisaType = !hasCreatedSmartForm;
  const smartserviceId = get(smartFormDraft, "0.smartserviceId", "");
  const [isShowDoc, setIsshowDoc] = useState(true);
  const { TypeOfUser } = useAuth();
  useEffect(async () => {
    const body = {
      isActivated: true,
      personalId: personalID,
    };
    const bodyShow = {
      personalId: personalID,
    };
    dispatch(getListSmartForm());
    dispatch(getSmartFormList2(body));
    const isShow = await dispatch(getConditionShowLTR(bodyShow));
    setIsshowDoc(isShow?.payload?.isShow);
  }, [dispatch]);

  useEffect(() => {
    if (isShowDoc === false) {
      Swal.fire({
        title: "Your LTR application is in process.",
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: "OK",
        icon: "warning",
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          dispatch(
            setHomeTab(HOME_TAB.CHECK_STATUS)
          );
        }
      });
    }
  }, [isShowDoc]);
  const handleClickContinue = () => {
    if (smartserviceId) {
      dispatch(setSmartServiceId(smartserviceId));
      dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
      dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
    }
  };

  return (
    <div>
      {/* <TargetIndustries /> */}

      <ContentTitle subTitle="" title="LTR" />
      {console.log(isShowDoc)}
      {isShowDoc ? <LtrType /> : null}

      {listSmartFormState.isLoading ? (
        <div style={{ marginTop: 24 }}>
          <Loading />
        </div>
      ) : (
        <>
          {/* {shouldShowContinue && (
                        <div style={{ marginTop: 24 }}>
                            <Paper style={{ padding: 24 }}>
                                <ContentTitle
                                    atitle="Continue you process"
                                    title="Application Form is not finished yet."
                                    subTitle="Smart form document"
                                />
                                <div style={{ marginTop: 16 }} />
                                <ColorButton
                                    variant="contained"
                                    color="success"
                                    onClick={handleClickContinue}
                                >
                                    Continue process..
                                </ColorButton>{" "}
                            </Paper>
                        </div>
                    )} */}
          {/* {shouldShowVisaType && <VisaType />} */}
          {/* {hasSmartFormComplete && <VisaStatusCard />} */}
          {/* {
            ownVisaList.length > 0 &&
            <VisaStatusCard />
          } */}

          {/* <VisaStatusCard /> */}
        </>
      )}

      {/* <TypeOfSmartVisa /> */}
    </div>
  );
}

export default LtrServiceTab;
